const imageManagerOdonto = {
  banners: {
    BannerOdonto:
      "https://storage.googleapis.com/primesecure/banner-odonto.webp",
  },
  logos: {
    SulAmericaLogo:
      "https://storage.googleapis.com/primesecure/sulamerica-logo.webp",
  },
  promo: {
    outubroRosa: "https://storage.googleapis.com/primesecure/Outubro.png",
    outubroAzul: "https://storage.googleapis.com/primesecure/novembro-azul.png",
    blackFriday:
      "https://storage.googleapis.com/primesecure/black-friday_160-x-80-px_.webp",
    natal: "https://storage.googleapis.com/primesecure/Natal.png",
    anoNovo: "https://storage.googleapis.com/primesecure/boas-festas.png",
  },
};

export default imageManagerOdonto;
